document.addEventListener("DOMContentLoaded", () => {
  var $AnnPriceEl = $(".ann-nav-list .cart_icon .total_price");
  var $AnnCount = $(".ann-nav-list .cart_icon .cart_count");
  var $CartTotal = $(".totals__total-value");

  var originalCartPriceText = $AnnPriceEl.text().trim();
  var bundlerDiscountedPriceText = null;

  function formatCents(cents) {
    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, Shopify.money_format || "${{amount}}");
    }

    var symbolMatch = originalCartPriceText.match(/^[^\d]+/);
    var symbol = symbolMatch ? symbolMatch[0] : "$";
    var amount = (Number(cents) / 100).toFixed(2);
    if (amount.endsWith(".00")) {
      amount = amount.slice(0, -3);
    }
    return symbol + amount;
  }

  function getOriginalCartPriceText() {
    if (!$CartTotal.length) {
      return originalCartPriceText;
    }

    if (!$CartTotal.hasClass("bundler-cart-price-info-container")) {
      return ($CartTotal.find(".money").first().text() || $CartTotal.text()).trim();
    }

    var strikethroughText = $CartTotal.find("s").first().text().trim();
    if (strikethroughText) {
      return strikethroughText;
    }

    return ($CartTotal.find(".money").first().text() || $CartTotal.text()).trim();
  }

  function updateCartCount() {
    var itemCount = $CartTotal.data("item-count");
    if (itemCount !== undefined) {
      $AnnCount.text("(" + itemCount + ")");
    }
  }

  function updateAnnPriceDisplay() {
    var displayPrice = bundlerDiscountedPriceText || originalCartPriceText;
    if (displayPrice) {
      $AnnPriceEl.text(displayPrice);
    }
    updateCartCount();
  }

  function syncOriginalCartPrice() {
    var cartPrice = getOriginalCartPriceText();
    if (cartPrice) {
      originalCartPriceText = cartPrice;
    }

    if (!$(".bndlr-cart-discounted-value").length) {
      bundlerDiscountedPriceText = null;
    }

    updateAnnPriceDisplay();
  }

  document.addEventListener("bundler:total_cart_values", function (e) {
    var detail = e.detail || {};
    var discountAmount = Number(detail.discount_amount) || 0;

    if (discountAmount > 0 && detail.total_amount_discounted != null) {
      bundlerDiscountedPriceText = formatCents(detail.total_amount_discounted);
      if (detail.total_amount_original != null) {
        originalCartPriceText = formatCents(detail.total_amount_original);
      }
    } else {
      bundlerDiscountedPriceText = null;
    }

    updateAnnPriceDisplay();
  });

  var cartIconBubble = document.querySelector("#cart-icon-bubble");
  if (cartIconBubble) {
    new MutationObserver(function () {
      syncOriginalCartPrice();
    }).observe(cartIconBubble, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  var $Hmtl = $("html,body");

  $(".ann-top-btn").click(function () {
    $Hmtl.animate({ scrollTop: 0 }, 300);
  });
});
